module.exports = __webpack_public_path__ + "img/user-bg-other.c867ee4b.png";